import React from 'react';
import { howItWorks } from '../../data/mock';
import { ArrowRight } from 'lucide-react';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-slate-900/30 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMyMDI5M2EiIGZpbGwtb3BhY2l0eT0iMC40Ij48Y2lyY2xlIGN4PSIxIiBjeT0iMSIgcj0iMSIvPjwvZz48L2c+PC9zdmc+')] opacity-40" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-amber-500/10 text-amber-400 text-sm font-medium mb-4">
            How It Works
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Get Started in
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-amber-400">
              {' '}Minutes
            </span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Simple setup, powerful results. Connect your loadboards and start searching immediately.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-24 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-sky-500/20 via-amber-500/50 to-sky-500/20" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {howItWorks.map((item, index) => (
              <div key={item.step} className="relative">
                {/* Step Card */}
                <div className="bg-slate-900/70 border border-slate-800 rounded-2xl p-8 h-full hover:border-sky-500/30 transition-all duration-300 group">
                  {/* Step Number */}
                  <div className="relative z-10 w-16 h-16 rounded-2xl bg-gradient-to-br from-sky-500 to-amber-500 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                    <span className="text-2xl font-bold text-slate-950">{item.step}</span>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold text-white mb-3">{item.title}</h3>
                  <p className="text-slate-400 leading-relaxed">{item.description}</p>

                  {/* Arrow for desktop */}
                  {index < howItWorks.length - 1 && (
                    <div className="hidden lg:flex absolute -right-4 top-24 z-20">
                      <ArrowRight className="w-6 h-6 text-amber-500" />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
